export const bsaTenant = "tenant";
export const bsaFascicolo = "fascicolo";
export const bsaAnagrafica = "anagrafica";
export const bsaPrestazione = "prestazione";
export const bsaRischio = "rischio";
export const bsaAutovalutazione = "autovalutazione";
export const bsaSegnalazione = "segnalazione";
export const bsaNormativa = "normativa";
export const bsaSettingsTabellaBase = "settings_tabella_base";
export const bsaSettingsUser = "settings_user";
export const bsaSettingsAudit = "settings_audit";
export const bsaSettingsPermission = "settings_permission";
export const bsaSettingsReleaseNotes = "settings_releasenotes";
export const bsaSettingsExport = "exportDati";
export const bsaSettingsNominations = "settings_nomination";